module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.5-116.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.5.md
// module id = 535
// module chunks = 275